// Small angle/number helpers, inlined from the former @wemap/maths-legacy so the
// navigation instruction managers below no longer depend on a legacy package.

export function rad2deg(rad: number): number {
    return rad * 180 / Math.PI;
}

export function diffAngle(angle1: number, angle2: number): number {
    return Math.atan2(Math.sin(angle1 - angle2), Math.cos(angle1 - angle2));
}

export function roundFactor(num: number, factor: number): number {
    return Math.round(num / factor) * factor;
}
